import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/harshhasthkala/harshhasthkala/src/app/product-detail/[productName]/ProductDetailClient.jsx");
